<template>
  <div class="currMaxImg">
    <el-dialog :append-to-body="true" title="查看大图" :visible.sync="maxImg"  class="Administration_dialog l_maxing">
      <div class="mImg">
        <div style="position: relative; background: #eee; margin: 10px;">
          <img src="../assets/left.png" style="position: absolute;cursor: pointer;top: 50%;left: 20px;" @click="prevImag" v-if="!isOneImage">
          <div style="min-height: 740px;margin: 0 auto;display: block;line-height: 740px; overflow: auto; position: relative;">
            <img ref="img" :src="maxurl" class="dimg" :style="{ transform:  'rotate(' + deg + 'deg) scale(' + scale +')', left: x + 'px', top: y + 'px', cursor: 'grab'}"
              @mousedown.prevent="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp" />
          </div>
          <img src="../assets/right.png" style="position: absolute;cursor: pointer;top: 50%;right: 20px;" @click="nextImag" v-if="!isOneImage">
        </div>
        <div style="margin-top: 10px; margin-bottom: 10px; display: flex; align-items: center; justify-content: center;">
          <div style="margin-right: 10px;" v-if="!isOneImage">{{maxIndex + 1}}/{{maxImages.length}}</div>
          <span style="margin-right: 10px; font-size: 22px;" v-if="!isOneImage">|</span>
          <i class="el-icon-zoom-out" style="cursor: pointer; font-size: 22px; margin-right: 10px;" @click="changeZoomOut"></i>
          <span style="margin-right: 10px;">{{ (scale * 100).toFixed(0) }}%</span>
          <i class="el-icon-zoom-in" style="cursor: pointer; font-size: 22px; margin-right: 10px;" @click="changeZoomIn"></i>
           <span style="margin-right: 10px; font-size: 22px;">|</span>
          <i class="el-icon-refresh-right" style="cursor: pointer; font-size: 22px;" @click="changeDeg"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'maximg',
  data() {
    return{
      maxImg: false,
      maxurl: '',
      isOneImage: true,
      maxIndex: 0,
      maxImages: [],
      deg: 0,
      scale: 1,
      draggingImage: false,
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
    }
  },
  methods: {
    handleMouseDown(e) {
      this.draggingImage = true;
      this.startX = e.clientX - this.x;
      this.startY = e.clientY - this.y;
    },
    handleMouseMove(e) {
      if (this.draggingImage) {
        this.x = e.clientX - this.startX;
        this.y = e.clientY - this.startY;
      }
    },
    handleMouseUp(e) {
      this.draggingImage = false;
    },
    changeZoomOut() {
      this.scale = this.scale - 0.25;
      if (this.scale <= 0.25) {
        this.scale = 0.25;
      }
    },
    changeZoomIn() {
      this.scale = this.scale + 0.25;
      if (this.scale >= 10) {
        this.scale = 10;
      }
    },
    openimgDialog(url){
      this.isOneImage = true;
      this.maxImg = true;
      this.maxurl = url;
      this.deg = 0;
      this.scale = 1;
      this.draggingImage = false;
      this.x = 0;
      this.y = 0;
      this.startX = 0;
      this.startY =0;
    },
    openImgsDialog(index, urls) {
      if (urls.length > 1) {
        this.isOneImage = false;
      } else {
        this.isOneImage = true;
      }
      this.deg = 0;
      this.scale = 1;
      this.draggingImage = false;
      this.x = 0;
      this.y = 0;
      this.startX = 0;
      this.startY =0;
      this.maxImg = true;
      this.maxurl = urls[index];
      this.maxIndex = index;
      this.maxImages = urls;
    },
    prevImag() {
      this.maxIndex = this.maxIndex - 1;
      if (this.maxIndex < 0) {
        this.maxIndex = this.maxImages.length - 1;
      }
      this.deg = 0;
      this.scale = 1;
      this.draggingImage = false;
      this.x = 0;
      this.y = 0;
      this.startX = 0;
      this.startY =0;
      this.maxurl = this.maxImages[this.maxIndex];
    },
    nextImag() {
      this.maxIndex = this.maxIndex + 1;
      if (this.maxIndex > this.maxImages.length - 1) {
        this.maxIndex = 0;
      }
      this.deg = 0;
      this.scale = 1;
      this.draggingImage = false;
      this.x = 0;
      this.y = 0;
      this.startX = 0;
      this.startY =0;
      this.maxurl = this.maxImages[this.maxIndex];
    },
    changeDeg() {
      if (this.deg === 270) {
        this.deg = 0;
      } else {
        this.deg = this.deg + 90;
      }
    },
  }
}
</script>
<style  lang="scss">
.l_maxing{
  .el-dialog{
    margin-top: 10vh!important;
    width: 1200px;
    min-height: 760px;
    text-align: center;
    vertical-align: middle;
    .el-dialog__body{
      height: 740px;
      width: 1200px;
      display:table-cell;
      vertical-align:middle;
      padding: 0!important;
    }
    .dimg{
      -webkit-user-drag: none;
      position: relative;
      max-width: 760px;
      max-height: 740px;
      margin: 0 auto;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MaxImg.vue